import { useState } from 'react';
import Header from '../Header';
import Footer from '../Footer';
import { validateAccessCode, goToReader } from '../services/accessCodeService';

/**
 * Reusable "enter your VIP code" gate, shared by the eBook and Audiobook
 * access pages. Reuses the exact classNames from the original Blade
 * views (accessBook.blade.php / accessAudioBook.blade.php) so the design
 * is unchanged - those styles already ship in css/App.css / read.css,
 * which are imported globally in App.jsx.
 *
 * @param {'EBOOK'|'AUDIOBOOK'} type
 * @param {string} title - e.g. "EBOOK" / "AUDIOBOOK"
 * @param {string} imageSrc - matches the asset() path used in the Blade view
 * @param {string} buttonLabel - e.g. "ACCESS EBOOK"
 */
function AccessCodeGate({ type, title, imageSrc, buttonLabel }) {
  const [code, setCode] = useState('');
  const [error, setError] = useState('');
  const [submitting, setSubmitting] = useState(false);

  async function handleSubmit(e) {
    e.preventDefault();
    if (!code.trim() || submitting) return;

    setSubmitting(true);
    setError('');

    try {
      const result = await validateAccessCode(type, code.trim());
      if (result.valid) {
        goToReader(type, code.trim());
        // Full navigation is in flight; keep the button disabled rather
        // than resetting submitting state.
        return;
      }
      setError(result.message || 'Code not found!');
      setSubmitting(false);
    } catch (err) {
      setError('Something went wrong. Please try again.');
      setSubmitting(false);
    }
  }

  return (
    <div>
      <Header />

      <div style={{ backgroundColor: '#000' }}>
        <div className="speaking_slider_all d-flex justify-content-center">
          <div className="col-sm-8 py-5 m-auto">
            <div className="row py-3">
              <div className="col-sm-6 align-self-center">
                <div className="px-2">
                  <img src={imageSrc} className="w-100" alt="" />
                </div>
              </div>
              <div className="col-sm-6 align-self-center">
                <div className="podcast_part3 pb-5 mt-3" id="STARTED">
                  <h1
                    style={{ fontWeight: 900, fontSize: 42, color: '#FFFFFF' }}
                    className="text-center"
                  >
                    {title}
                  </h1>
                  <div
                    style={{ fontWeight: 900, fontSize: 20 }}
                    className="text-white text-center mb-2"
                  >
                     ACCESS TO <br />PERSIST, PERSIST, PERSIST.
                  </div>
                  <div className="justify-content-center shadow-lg px-5 bg-white">
                    {error && <div className="text-danger">{error}</div>}

                    <div className="form" style={{ padding: "30px 0px" }}>
                      <form onSubmit={handleSubmit}>
                        <input
                          name="query"
                          className="input_part2_jett"
                          placeholder="Enter your special code here..."
                          type="text"
                          autoFocus
                          required
                          value={code}
                          onChange={(e) => setCode(e.target.value)}
                          disabled={submitting}
                        />
                        <button
                          type="submit"
                          className="btn_part2_jett mt-2 py-1"
                          disabled={submitting || !code.trim()}
                        >
                          {submitting ? 'Checking…' : buttonLabel}
                        </button>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
}

export default AccessCodeGate;
